import * as React from 'react'

function BookIcon(props) {
  return (
    <svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.867 25.333V6.667c0-.708.283-1.386.787-1.886A2.695 2.695 0 017.552 4h17.455c.712 0 1.395.28 1.899.781.503.5.786 1.178.786 1.886V20c0 .707-.283 1.386-.786 1.886-.504.5-1.187.78-1.899.78H7.552c-.712 0-1.395.282-1.898.782a2.657 2.657 0 000 3.771c.503.5 1.186.781 1.898.781h17.455c.712 0 1.395-.281 1.899-.781.503-.5.786-1.178.786-1.886v-6.666M22.322 10.21H10.238M22.322 16H10.238"
        stroke="#1F2D27"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { BookIcon }
